document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.button-group button');
  const chartContainer = document.getElementById('chart-container');

  // Function to load the section
  function loadSection(sectionId) {
    // Step 1: Fade out the current content
    chartContainer.style.opacity = 0;

    // Step 2: After fade-out, load the new section content
    setTimeout(function () {
      // Use AJAX to fetch the corresponding section
      fetch(`?section_id=${sectionId}`)
        .then(response => response.text())
        .then(data => {
          chartContainer.innerHTML = data; // Insert the new section content
          chartContainer.style.opacity = 1; // Fade-in the new content
        });
    }, 500);  // Wait for fade-out transition to complete
  }

  // Automatically load the section for the active button on page load
  const activeButton = document.querySelector('.button-group button.active');
  if (activeButton) {
    const sectionId = activeButton.getAttribute('data-section');
    loadSection(sectionId);  // Load the section for the active button
  }

  // Add event listeners to each button
  buttons.forEach(button => {
    button.addEventListener('click', function() {
      // Remove 'active' class from all buttons
      buttons.forEach(btn => btn.classList.remove('active'));

      // Add 'active' class to the clicked button
      this.classList.add('active');

      // Load the associated section
      const sectionId = this.getAttribute('data-section');
      loadSection(sectionId);
    });
  });
});

// Get all buttons in the button group
const buttons = document.querySelectorAll('.button-group button');

buttons.forEach(button => {
  button.addEventListener('click', function() {
    buttons.forEach(btn => btn.classList.remove('active'));
    this.classList.add('active');
  });
});